import { find, map } from 'lodash';
import analytics from 'common/analytics';
import { captureApiError } from 'common/monitoring/sentry';

export const MESSAGE_SESSION_END = 'Your session has expired or it has been invalidated. Please sign in again!';

export function getRepeatEndFieldError(result) {
    let errors = result && result.data && result.data.errors;

    if (!errors) {
        return null;
    }

    let field = find(Object.keys(errors), (key) => {
        let normalizedKey = key.toLowerCase();
        let isEndingField = normalizedKey.indexOf('end') !== -1
            || normalizedKey.indexOf('occurrence') !== -1;
        return isEndingField
            && (normalizedKey.indexOf('repeat') !== -1
                || normalizedKey.indexOf('date') !== -1
                || normalizedKey.indexOf('occurrence') !== -1);
    });

    if (!field) {
        return null;
    }

    let message = errors[field];
    if (message === null || typeof message === 'undefined') {
        return null;
    }

    return Array.isArray(message) ? message.join(', ') : String(message);
}

export function getErrorMessage(result, fallbackMessage) {
    // catched exception
    if (result instanceof Error) {
        return result.message || fallbackMessage;
    }

    if (typeof result === 'string') {
        return result || fallbackMessage;
    }

    result = result || {};

    switch (result.status) {
        case 0:
            return `We are having maintenance at the moment or you might have network connectivity issues. Anyway, grab a cup of coffee and try again a bit later.`;
        case 500:
            return `We are sorry but something failed in the deep. Grab a cup of coffee and try again later.`;
        case 502:
        case 503:
            return `No worries, we are having a break at the moment for maintenance. Grab a cup of coffee and try again later.`;
    }

    let data = result.data || {};

    switch (data.error) {
        case 'BAD_REQUEST': {
            let errors = data.errors || {};
            let keys = Object.keys(errors);

            if (keys.length > 0) {
                let message = keys.map((field) => {
                    let name = field.replace(/([A-Z])/g, (letter) => ` ${letter.toLowerCase()}`);
                    return `${name} ${errors[field]}`;
                }).join(', ');

                return `Validation errros occured. The ${message}.`;
            }

            return data.message;
        }
        case 'ACCOUNT_EXPIRED':
            return `Your account expired because you forgot to verify your email address.`;
        case 'INVALID_GRANT':
            return MESSAGE_SESSION_END;
        case 'USERNAME_IN_USE':
            return `It looks like this email address is already in use.`;
        case 'UPDATE_REQUIRED':
            return `There is an updated version available. Please reload the page in your browser.`;
    }

    return fallbackMessage;
}

export function trackError(result) {
    const { status, data, config } = result || {};
    const { error } = data || {};
    const { method, url } = config || {};
    const shouldRedactBackendMessage = status === 0 || status >= 500;

    let message = shouldRedactBackendMessage
        ? 'Server error'
        : data && data.message ? data.message : '';

    switch (status) {
        case 401: {
            return analytics.trackSessionEnd('Session');
        }
    }

    switch (error) {
        case 'ACCOUNT_EXPIRED': {
            return analytics.trackSessionEnd('Unverified account');
        }

        case 'BAD_REQUEST': {
            let errors = data.errors || {};
            let errorFields = Object.keys(errors);

            if (errorFields.length > 0) {
                let fieldErrorMessage = map(errorFields, (key) => `${key}: ${errors[key]}`).join(', ');
                message += ` [${fieldErrorMessage}]`;
            }

            break;
        }
    }

    captureApiError(result);

    return analytics.trackApiError(status, error, message, method, url);
}

export function updateErrorMessage(result, message) {
    // catched exception
    if (result instanceof Error) {
        return new Error(message);
    }

    // raised application error
    if (typeof result === 'object') {
        result.message = message;
        return result;
    }

    // something else
    return message;
}



// WEBPACK FOOTER //
// ./src/application/util/error.util.js